module.exports = __webpack_public_path__ + "static/img/login_icon_left.9de5861f.png";